/** Operator-facing labels — commitment/promise only; no payment/receipt/settlement wording. */

export const COLLECTION_COMMITMENT_OPERATOR_LABELS = {
  actionRecord: '후속 약속 기록',
  actionRecordEn: 'Record commitment',
  drawerTitle: '약속 기록',
  boundaryHint:
    '약속 기록은 고객이 말한 후속 일정을 남기는 것입니다. 수금 처리나 영수증이 아닙니다.',
  boundaryHintEn: 'This records what the customer said they will do. It does not apply payment.',
  paymentFlowHint: '입금 확인·결제 반영은 영수증 등록 흐름에서만 진행합니다.',
  createSuccess: '약속을 기록했습니다.',
  createFailed: '약속을 기록하지 못했습니다.',
  cancelSuccess: '약속을 취소했습니다.',
  cancelFailed: '약속을 취소하지 못했습니다.',
  cancelNotAllowed: '이미 취소되었거나 취소할 수 없는 약속입니다.',
  listFailed: '약속 목록을 불러오지 못했습니다.',
  unwiredHandler: '약속 기록 실행 경로가 연결되지 않았습니다.',
  missingArEntry:
    '선택한 항목에서 AR ID를 확인할 수 없습니다. 미수금(AR) 목록에서 다시 선택해 주세요.',
  promisedDatePast: '약속일 지남',
  promisedDatePastEn: 'Past promised date',
  statusPending: '대기',
  statusCancelled: '취소됨',
  statusFulfilled: '이행',
  statusBroken: '미이행',
  statusBrokenObservation: '약속일 경과 (관찰)',
  statusFulfilledObservation: 'AR 정리 관찰',
  cancelAction: '약속 취소',
  createAction: '약속 저장',
  promisedAmountLabel: '약속 금액 (선택)',
  promisedDateLabel: '약속일 (선택)',
  notesLabel: '메모 (선택)',
  collectionStageLabel: '팔로업 단계 (선택)',
  existingCommitmentsSectionTitle: '기존 약속',
  newCommitmentSectionTitle: '새 약속 기록',
  promisedAmountRowPrefix: '약속 금액:',
  promisedDateRowPrefix: '약속일:',
  collectionStageRowPrefix: '팔로업 단계:',
  notesRowPrefix: '메모:',
  optionalInputPlaceholder: '선택 입력',
  emptyList: '등록된 약속이 없습니다.',
  revisitRecommendationCopy: '미이행 약속이 있습니다. 재방문 일정을 검토해 주세요.',
  revisitRecommendationHint: '자동 연락·법적 조치는 실행되지 않습니다.',
} as const;
